/* 全局getter，同时负责导出专家与用户专属getter */
export const currSessionFormatMsgs = state => state.currSessionFormatMsgs;
export const currSessionMsgs = state => state.currSessionMsgs;
export const noMoreHistoryMsgs = state => state.noMoreHistoryMsgs;



// WEBPACK FOOTER //
// ./src/store/nim/getters.js